import type { FilterField, SelectFilterField } from '@/components/common/AdvancedFilter';
import type { PromoItem } from '@/features/promotion/types/promotion.types';
import { toFilterOptions } from '@/utils/filters';
import { DECISION_OPTIONS } from '../constants/marketPromotion.constants';

const DONATION_ITEM_LABEL = 'Donation Item';
const ALL_ITEMS_PLACEHOLDER = 'All Items';

export function getDonationItemFilterField(items: PromoItem[] | undefined): SelectFilterField {
  return {
    key: 'promoItemId',
    label: DONATION_ITEM_LABEL,
    type: 'select',
    placeholder: ALL_ITEMS_PLACEHOLDER,
    options: toFilterOptions(items),
    searchable: true,
  };
}

export function getDonationItemsFilterField(items: PromoItem[] | undefined): FilterField {
  return {
    key: 'promoItemIds',
    label: DONATION_ITEM_LABEL,
    type: 'multiSelect',
    placeholder: ALL_ITEMS_PLACEHOLDER,
    options: toFilterOptions(items),
  };
}

export function getDecisionStatusFilterField(): FilterField {
  return {
    key: 'approveTypeNos',
    label: 'Status',
    type: 'multiSelect',
    placeholder: 'All',
    options: toFilterOptions(DECISION_OPTIONS),
  };
}

export function getDonationContactFilterFields(): FilterField[] {
  return [
    { key: 'teacherMobile', label: 'Teacher Phone No', type: 'text', placeholder: '01XXXXXXXXX' },
    { key: 'instituteEiin', label: 'Institute EIIN', type: 'text', placeholder: '123456' },
    { key: 'enteredMobile', label: 'ZM Mobile', type: 'text', placeholder: '01XXXXXXXXX' },
  ];
}
